import Audit from "./Audit/Routes";
import Journal from "./Journal/Routes";
import Payment from "./Payment/Routes";
import Purchase from "./Purchase/Routes";
import Received from "./Received/Routes";
import Recipe from "./Recipe/Routes";
import Sales from "./Sales/Routes";
import DailyCash from "./DailyCash/Routes";

export default [...Audit, ...Journal, ...Payment, ...Received, ...Purchase, ...Recipe, ...Sales, ...DailyCash];
